import { render, staticRenderFns } from "./CheckoutMiniCart.vue?vue&type=template&id=523621f8"
import script from "./CheckoutMiniCart.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutMiniCart.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports